// Get an element's absolute position on the page.
export function getOffset(el: Element) {
    const rect = el.getBoundingClientRect();

    return {
        left: rect.left + (window.scrollX || window.pageXOffset),
        top: rect.top + (window.scrollY || window.pageYOffset),
    };
}



// WEBPACK FOOTER //
// ./js/common/utils/boxPosition.ts